/**
 * Texto enriquecido del PMS (condiciones, guía, preguntas frecuentes) como texto plano (D49). No se inyecta
 * marcado: los saltos de párrafo, `<br>` y elementos de lista se conservan como saltos de línea y la pantalla lo
 * pinta con `white-space: pre-line`. Enlaces e imágenes en línea se pierden; las fotos de la guía van aparte.
 */
export function plainText(html: string): string {
  const withBreaks = html
    .replace(/<br\s*\/?>/gi, '\n')
    .replace(/<\/(p|div|li|h[1-6]|tr)>/gi, '\n')
    .replace(/<li[^>]*>/gi, '• ')
  if (typeof DOMParser === 'undefined') return withBreaks.replace(/<(script|style)[\s\S]*?<\/\1>/gi, '').replace(/<[^>]*>/g, ' ').trim()
  const doc = new DOMParser().parseFromString(withBreaks, 'text/html')
  for (const el of doc.querySelectorAll('script, style')) el.remove()
  return (doc.body.textContent ?? '')
    .replace(/[ \t]+\n/g, '\n')
    .replace(/\n{3,}/g, '\n\n')
    .trim()
}
